import { gql, TypedDocumentNode } from "@apollo/client";

export type DepartmentsQueryResponse = {
  departments: string[];
};

export const DEPARTMENTS_QUERY: TypedDocumentNode<DepartmentsQueryResponse> = gql`
  query DepartmentsQuery {
    departments
  }
`;
